import {
  getAllTeams as getAllTeamsCall,
  getAllSeasons as getAllSeasonsCall,
  getSeasonsByCompetition as getSeasonsByCompetitionCall,
  getAllCompetitions as getAllCompetitionsCall,
  getAllPlayers as getAllPlayersCall,
  getAllShirtTypes as getAllShirtTypesCall,
  getAllVariants as getAllVariantsCall,
  getAllBrands as getAllBrandsCall,
  getAllConditions as getAllConditionsCall,
  getAllProperties as getAllPropertiesCall,
  getTeamsByCompetitionAndSeason as getTeamsByCompetitionAndSeasonCall,
  getTeamsByCompetitionWithCount as getTeamsByCompetitionWithCountCall,
  getAllPlayersByTeamAndSeasonAndCompetition as getAllPlayersByTeamAndSeasonAndCompetitionCall,
  getTeamsByNationalTeamValue as getTeamsByNationalTeamValueCall,
  getTeamsByNationalTeamValueWithCount as getTeamsByNationalTeamValueWithCountCall,
  getNumbersByPlayerInfo as getNumbersByPlayerInfoCall,
  getBrandByTeamAndSeason as getBrandByTeamAndSeasonCall,
} from "../api/shirtModelService";
import LoginService from "../loginService";
import NotificationService from "../../components/Notification/notificationService";
import { Shirt } from "../../entities/Shirt";
import { ShirtModel } from "../../entities/ShirtModel";
import {
  Brand,
  Competition,
  Condition,
  Player,
  Property,
  Season,
  ShirtType,
  Signature,
  Team,
  Variant,
} from "./types";

export default function ShirtModelService() {
  const { error: errorNotification } = NotificationService();
  const { setLogout } = LoginService();

  const handleError = (status: number, description: string) => {
    if (status === 401) {
      setLogout();
    } else {
      errorNotification(description);
    }
  };

  const getAllTeams = async () => {
    let response = await getAllTeamsCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Team> = response.data;
      return data;
    } else {
      return undefined;
    }
  };

  const getTeamsByCompetitionAndSeason = async (
    competition_id: string,
    season_id: string
  ) => {
    let response = await getTeamsByCompetitionAndSeasonCall(
      competition_id,
      season_id
    ).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Team> = response.data.teams;
      return data;
    } else {
      return undefined;
    }
  };

  const getTeamsByCompetitionWithCount = async (competition_id: string) => {
    let response = await getTeamsByCompetitionWithCountCall(
      competition_id
    ).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Team> = response.data.teams;
      return data;
    } else {
      return undefined;
    }
  };

  const getTeamsByNationalTeamValue = async (national_team: boolean) => {
    let response = await getTeamsByNationalTeamValueCall(national_team).catch(
      function (error) {
        const status = error.response.status;
        const description = error.response.data.error_description;
        handleError(status, description);
      }
    );
    if (response?.data) {
      const data: Array<Team> = response.data.teams;
      return data;
    } else {
      return undefined;
    }
  };

  const getTeamsByNationalTeamValueWithCount = async (
    national_team: boolean
  ) => {
    let response = await getTeamsByNationalTeamValueWithCountCall(
      national_team
    ).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Team> = response.data.teams;
      return data;
    } else {
      return undefined;
    }
  };

  const getAllSeasons = async () => {
    let response = await getAllSeasonsCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Season> = response.data;
      return data;
    } else {
      return undefined;
    }
  };

  const getSeasonsByCompetition = async (competition_id: string) => {
    try {
      const { data } = await getSeasonsByCompetitionCall(competition_id);
      return data ? (data as Array<Season>) : undefined;
    } catch (error: any) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    }
  };

  const getAllCompetitions = async () => {
    let response = await getAllCompetitionsCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Competition> = response.data;
      return data;
    } else {
      return undefined;
    }
  };
  const getAllPlayers = async () => {
    let response = await getAllPlayersCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Player> = response.data;
      return data;
    } else {
      return undefined;
    }
  };

  const getAllPlayersByTeamAndSeasonAndCompetition = async (
    competition_id: string,
    season_id: string,
    team_id: string
  ) => {
    let response = await getAllPlayersByTeamAndSeasonAndCompetitionCall(
      competition_id,
      season_id,
      team_id
    ).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Player> = response.data.players;
      return data;
    } else {
      return undefined;
    }
  };
  const getAllTypes = async () => {
    let response = await getAllShirtTypesCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<ShirtType> = response.data;
      return data;
    } else {
      return undefined;
    }
  };
  const getAllVariants = async () => {
    let response = await getAllVariantsCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Variant> = response.data;
      return data;
    } else {
      return undefined;
    }
  };
  const getAllBrands = async () => {
    let response = await getAllBrandsCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Brand> = response.data;
      return data;
    } else {
      return undefined;
    }
  };
  const getAllConditions = async () => {
    let response = await getAllConditionsCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Condition> = response.data;
      return data;
    } else {
      return undefined;
    }
  };

  const getAllProperties = async () => {
    let response = await getAllPropertiesCall().catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Property> = response.data;
      return data;
    } else {
      return [];
    }
  };

  const getNumbersByPlayerInfo = async (
    competitionId: string,
    seasonId: string,
    teamId: string,
    playerId: string
  ) => {
    let response = await getNumbersByPlayerInfoCall(
      competitionId,
      seasonId,
      teamId,
      playerId
    ).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<number> = response.data.numbers;
      return data;
    } else {
      return [];
    }
  };

  const getBrandByTeamAndSeason = async (
    competitionId: string,
    seasonId: string,
    teamId: string,
    shirtTypeId: number
  ) => {
    let response = await getBrandByTeamAndSeasonCall(
      competitionId,
      seasonId,
      teamId,
      shirtTypeId
    ).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const data: Array<Brand> = response.data.brands;
      return data;
    } else {
      return [];
    }
  };

  return {
    getAllTeams,
    getAllSeasons,
    getAllCompetitions,
    getAllPlayers,
    getAllTypes,
    getAllVariants,
    getAllBrands,
    getAllConditions,
    getAllProperties,
    getTeamsByCompetitionAndSeason,
    getSeasonsByCompetition,
    getAllPlayersByTeamAndSeasonAndCompetition,
    getTeamsByCompetitionWithCount,
    getTeamsByNationalTeamValue,
    getTeamsByNationalTeamValueWithCount,
    getNumbersByPlayerInfo,
    getBrandByTeamAndSeason,
  };
}
